import { render, staticRenderFns } from "./TravelProgram.vue?vue&type=template&id=11961b20&"
import script from "./TravelProgram.vue?vue&type=script&lang=js&"
export * from "./TravelProgram.vue?vue&type=script&lang=js&"
import style0 from "./TravelProgram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports